export default __webpack_public_path__ + "static/media/comp.e54b5d08.gif";